import axios from "axios";
import React, { useEffect, useRef, useState, useCallback } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api";
import { DataHora } from "./Grid";
import DescricaoFinanceiro from "./DescricaoFinanceiro";

const FormContainer = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 0px 5px #ccc;
  border-radius: 5px;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  width: 100px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const InputId = styled.input`
  width: 30px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const Label = styled.label``;

const Button = styled.button`
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background-color: #2c73d2;
  color: white;
  height: 42px;
`;

const Select = styled.select`
  width: 120px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
  background-color: #fff;
`;

// --- Modal de Transferência ---
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalBox = styled.div`
  background: white;
  border-radius: 10px;
  padding: 28px 32px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.22);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ModalTitulo = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #1a5276;
`;

const ModalRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ModalLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #444;
`;

const ModalSelect = styled.select`
  padding: 8px 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  font-size: 14px;
  background: #fff;
`;

const ModalInput = styled.input`
  padding: 8px 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  font-size: 14px;
  width: 100%;
`;

const SaldoInfo = styled.div`
  font-size: 12px;
  color: #555;
  margin-top: 2px;

  strong {
    color: ${({ $negativo }) => ($negativo ? "#c0392b" : "#27ae60")};
  }
`;

const ModalBotoes = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

const BtnConfirmar = styled.button`
  padding: 9px 22px;
  border: none;
  border-radius: 6px;
  background: #27ae60;
  color: white;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;

  &:hover { background: #1e8449; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const BtnCancelar = styled.button`
  padding: 9px 22px;
  border: none;
  border-radius: 6px;
  background: #e0e0e0;
  color: #333;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;

  &:hover { background: #c0c0c0; }
`;

const BtnTransferir = styled.button`
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background-color: #8e44ad;
  color: white;
  height: 42px;
  font-weight: 600;
  font-size: 13px;

  &:hover { background-color: #6c3483; }
`;

const BtnRelatorio = styled.button`
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background-color: #16a085;
  color: white;
  height: 42px;
  font-weight: 600;
  font-size: 13px;

  &:hover { background-color: #117a68; }
`;

const Title = styled.h2``;

const FormFinancas = ({ getUsers, onEdit, setOnEdit }) => {
  const refCarga = useRef();
  const refEfetivar = useRef();

  const [usuarios, setUsuarios] = useState([]);
  const [movimento, setMovimento] = useState([]);
  const [descricao, setDescricao] = useState([]);
  const [saldo, setSaldo] = useState(null);

  const [financeiro, setFinanceiro] = useState([]);

  const [usrMov, setUsrMov] = useState("");
  const [vlMov, setVlMov] = useState("");

  const [descricaoFiltrada, setDescricaoFiltrada] = useState([]);
  const [movimentoSelecionado, setMovimentoSelecionado] = useState(null);
  const [modoRelatorio, setModoRelatorio] = useState(false);

  // --- Modal transferência ---
  const [modalAberto, setModalAberto] = useState(false);
  const [saldosUsuarios, setSaldosUsuarios] = useState([]);
  const [transferOrigem, setTransferOrigem] = useState("");
  const [transferDestino, setTransferDestino] = useState("");
  const [transferValor, setTransferValor] = useState("");
  const [transferindo, setTransferindo] = useState(false);

  const saldoOrigem = saldosUsuarios.find(u => u.id?.toString() === transferOrigem);
  const saldoDestino = saldosUsuarios.find(u => u.id?.toString() === transferDestino);

  function fmtValor(v) {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
  }

  const abrirModal = useCallback(async () => {
    try {
      const res = await api.get("liga/admin/saldos");
      setSaldosUsuarios(res.data.usuarios || []);
    } catch (e) {
      toast.error("Erro ao carregar saldos.");
      return;
    }
    setTransferOrigem("");
    setTransferDestino("");
    setTransferValor("");
    setModalAberto(true);
  }, []);

  async function confirmarTransferencia() {
    if (!transferOrigem || !transferDestino) {
      toast.warning("Selecione origem e destino.");
      return;
    }
    if (transferOrigem === transferDestino) {
      toast.warning("Origem e destino devem ser diferentes.");
      return;
    }
    const valor = parseFloat(transferValor.replace(",", "."));
    if (!valor || valor <= 0) {
      toast.warning("Informe um valor válido.");
      return;
    }
    setTransferindo(true);
    try {
      await api.post("liga/admin/transferirSaldo", {
        idOrigem: Number(transferOrigem),
        idDestino: Number(transferDestino),
        valor,
      });
      toast.success("Transferência realizada com sucesso!");
      setModalAberto(false);
      // Recarrega extrato se havia um usuário selecionado
      if (saldo) getFinanceiro(saldo.id);
    } catch (e) {
      toast.error(e.response?.data?.message || "Erro ao transferir saldo.");
    }
    setTransferindo(false);
  }

  function handleMovimentoChange(event) {
    const idMovimento = Number(event.target.value);
    setMovimentoSelecionado(idMovimento);
  
    if (idMovimento === 1) {
      // Entrada - só descrição com id=1
      const desc = descricao.filter(d => d.id === 1);
      setDescricaoFiltrada(desc);
    } else if (idMovimento === 2) {
      // Saída - descrição com id=2 e id=3
      const desc = descricao.filter(d => d.id === 2 || d.id === 3 || d.id === 4);
      setDescricaoFiltrada(desc);
    } else {
      setDescricaoFiltrada([]);
    }
  }
  

  function getMovimento(){
    return  [
      {
        id: 2,
        descricao: "Saída"
      },
      {
        id: 1,
        descricao: "Entrada"
      }
    ]
      
  }

  function getDescricao(){

    return  [
      {
        id: 1,
        descricao: "Recebimento cartola",
        descricaoCliente: "Pagamento cartola",
      },
      {
        id: 2,
        descricao: "Pagamento premiação",
        descricaoCliente: "Recebimento premiação"
      },
      {
        id: 3,
        descricao: "Rodada free",
        descricaoCliente: "Rodada free",
      },
      {
        id: 4,
        descricao: "Adição de créditos",
        descricaoCliente: "Adição de créditos",
      }
  ]

  }

 /* useEffect(() => {
    if (onEdit) {
      const user = ref.current;

      user.id.value = onEdit.id;
      user.nome.value = onEdit.nome;
      user.login.value= onEdit.login;
      user.senha.value= onEdit.senha;
      user.valor.value= onEdit.valor;
      user.telefone.value= onEdit.telefone;
     
    }
  }, [onEdit]);*/

  useEffect(() => {
    const loadStatusOptions = async () => {
      try {
        const response = await api.get("/liga/listarUsuarios"); // Exemplo de endpoint
        setUsuarios(response.data);
       
      } catch (error) {
        console.error("Erro ao buscar status:", error);
      }
    };

    var movi = getMovimento();
    var desc = getDescricao();

    setMovimento(movi)
    setDescricao(desc);
  
    loadStatusOptions();
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
  
    const idUsuarioSelecionado = event.target.usuarios.value; // <- pega o ID selecionado
  
    const usuario = usuarios.find(u => u.id.toString() === idUsuarioSelecionado); // acha o objeto
  
    if (usuario) {
      console.log("Usuário selecionado:", usuario.nome);
      setUsrMov(usuario.nome)
      setModoRelatorio(false);
      getFinanceiro(usuario.id);
   
    } else {
      console.log("Nenhum usuário selecionado.");
    }
  
    // aqui você pode continuar seu envio normalmente
  }

  async function handleDetalharSaldo(event) {
    event.preventDefault();

    if (!saldo?.id) {
      toast.warning("Selecione um usuário para abrir o relatório.");
      return;
    }

    setModoRelatorio(true);
    await getFinanceiro(saldo.id);
  }

  async function handleEfetivar(event) {
    event.preventDefault();
  
    const formData = new FormData(event.target);
  
    const dados = {
      id: 0,
      idUsuario: saldo.id, // pega o valor do input
      valor: Number(formData.get('valor').replace(",", ".")),     // pega o valor digitado
      movimento: Number(formData.get('movimentoId')), // pega o id selecionado
      descricaoMovimento: formData.get('descricaoId')  // pega o id selecionado
    };
  
     await api.post("/liga/inserirFinanceiro", dados)
        .then(({ data }) => toast.success(data))
        .catch(({ data }) => toast.error(data));
  }

  async function getFinanceiro(idUsuario) {
    try {
      const res = await api.get("liga/ListaFinanceiro/"+idUsuario);
      setFinanceiro(res.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  function handleUsuarioChange(event) {
    const idSelecionado = event.target.value;
    const usuario = usuarios.find(u => u.id.toString() === idSelecionado);
    setSaldo(usuario || null);
  }

  return (
    <>
      <FormContainer ref={refCarga} onSubmit={handleSubmit}>

        <InputArea>
          <Label>Usuário</Label>
          <Select name="usuarios" onChange={handleUsuarioChange}>
            <option value="">Selecione</option>
            {usuarios.map((usuario) => (
              <option key={usuario.id} value={usuario.id}>
                {usuario.nome}
              </option>
            ))}
          </Select>
        </InputArea>
      
        <InputArea>
          <Label>Créditos atuais</Label>
          <InputId name="credito" disabled value={saldo?.valor !== undefined ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(saldo.valor) : ""} />
        </InputArea>
        
        <Button type="submit">Carregar extrato</Button>
        <BtnRelatorio type="button" onClick={handleDetalharSaldo}>
          Relatório de saldo
        </BtnRelatorio>
        <BtnTransferir type="button" onClick={abrirModal}>
          Transferir Saldo
        </BtnTransferir>
      </FormContainer>

      <FormContainer ref={refEfetivar} onSubmit={handleEfetivar}>

        <InputArea>
          <Label>Usuário</Label>
          <Input name="usuario" disabled value={usrMov} />
        </InputArea>

        <InputArea>
          <Label>Valor</Label>
          <Input name="valor" />
        </InputArea>

        <InputArea>
          <Label>Movimento</Label>
          <Select name="movimentoId" onChange={handleMovimentoChange}>
            <option value="">Selecione</option>
            {movimento.map((m) => (
              <option key={m.id} value={m.id}>
                {m.descricao}
              </option>
            ))}
          </Select>
        </InputArea>


        <InputArea>
          <Label>Descrição</Label>
          <Select name="descricaoId">
            <option value="">Selecione</option>
            {descricaoFiltrada.map((d) => (
              <option key={d.id} value={d.descricao}>
                {d.descricaoCliente}
              </option>
            ))}
          </Select>
        </InputArea>


        <Button type="submit">Carregar</Button>
        </FormContainer>

        <DescricaoFinanceiro financeiro={financeiro} adm={true} modoRelatorio={modoRelatorio}/>

      {modalAberto && (
        <Overlay onClick={() => setModalAberto(false)}>
          <ModalBox onClick={e => e.stopPropagation()}>
            <ModalTitulo>Transferir Saldo entre Usuários</ModalTitulo>

            <ModalRow>
              <ModalLabel>De (origem)</ModalLabel>
              <ModalSelect
                value={transferOrigem}
                onChange={e => setTransferOrigem(e.target.value)}
              >
                <option value="">Selecione o usuário de origem</option>
                {saldosUsuarios.map(u => (
                  <option key={u.id} value={u.id}>{u.nome}</option>
                ))}
              </ModalSelect>
              {saldoOrigem && (
                <SaldoInfo $negativo={saldoOrigem.saldo < 0}>
                  Saldo atual: <strong>{fmtValor(saldoOrigem.saldo)}</strong>
                </SaldoInfo>
              )}
            </ModalRow>

            <ModalRow>
              <ModalLabel>Para (destino)</ModalLabel>
              <ModalSelect
                value={transferDestino}
                onChange={e => setTransferDestino(e.target.value)}
              >
                <option value="">Selecione o usuário de destino</option>
                {saldosUsuarios
                  .filter(u => u.id?.toString() !== transferOrigem)
                  .map(u => (
                    <option key={u.id} value={u.id}>{u.nome}</option>
                  ))}
              </ModalSelect>
              {saldoDestino && (
                <SaldoInfo $negativo={saldoDestino.saldo < 0}>
                  Saldo atual: <strong>{fmtValor(saldoDestino.saldo)}</strong>
                </SaldoInfo>
              )}
            </ModalRow>

            <ModalRow>
              <ModalLabel>Valor da transferência</ModalLabel>
              <ModalInput
                type="text"
                placeholder="Ex: 25,00"
                value={transferValor}
                onChange={e => setTransferValor(e.target.value)}
              />
            </ModalRow>

            <ModalBotoes>
              <BtnCancelar onClick={() => setModalAberto(false)}>Cancelar</BtnCancelar>
              <BtnConfirmar onClick={confirmarTransferencia} disabled={transferindo}>
                {transferindo ? "Transferindo..." : "Confirmar"}
              </BtnConfirmar>
            </ModalBotoes>
          </ModalBox>
        </Overlay>
      )}

      </>
  );
};

export default FormFinancas;
